<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeAddPointsDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100">
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode"
            [class.zx-ltr]="!isRTL">
            <span *ngIf="!isLoadingUpdates">
                <span *ngIf="action === 'add'">{{ "add-pts.title.add" | translate }}</span>
                <span *ngIf="action === 'remove'">{{ "add-pts.title.remove" | translate }}</span>
                <span class="zx-100-opp">-</span>
                <span>{{ user.email }}</span>
            </span>
            <span *ngIf="isLoadingUpdates" class="text-green">
                {{ "add-pts.success" | translate }}
            </span>
        </h4>

        <div class="d-flex flex-column gap-3 align-items-center w-100 pt-3" style="min-height: 210px;">

            <span *ngIf="!isSuccessfullyUpdated && !isLoadingUpdates" [class.zx-100-opp]="isLoadingUpdates"
                class="text-center pt-2 pt-lg-3" [class.zx-ltr]="!isRTL">
                <span>{{ "add-pts.explain-1" | translate }}</span>
                <span class="zx-100-opp">-</span>
                <span>{{ user.email }}</span>
                <span class="zx-100-opp">-</span>
                <span>{{ "add-pts.explain-2" | translate }}</span>
                <span class="zx-100-opp">-</span>
                <span>{{ user.points }}</span>
                <span class="zx-100-opp">-</span>
                <span>{{ "my-profile.points" | translate }}</span>
                <span>.</span>
            </span>

            <form *ngIf="!isSuccessfullyUpdated && !isLoadingUpdates" #myForm="ngForm"
                class="d-flex align-items-center gap-2" (ngSubmit)="onSubmit()">
                <div class="form-group input-width zx-z-index-1">
                    <select id="action" [(ngModel)]="action" name="action" class="form-control">
                        <option value="add">{{ "add-pts.btn-add" | translate }}</option>
                        <option value="remove">{{ "add-pts.btn-remove" | translate }}</option>
                    </select>
                </div>

                <div class="form-group input-width zx-z-index-1">
                    <input type="number" id="points" matInput [(ngModel)]="newPoints" name="points"
                        class="fw-bold input-width" placeholder="0" min="0">
                </div>

                <span>
                    <span class="d-sm-none">{{ "my-profile.eazix-points" | translate }}</span>
                    <span class="d-none d-sm-inline">{{ "my-profile.points" | translate }}</span>
                </span>

                <button type="submit" class="d-none"></button>
            </form>

            <span class="spacer"></span>

            <div *ngIf="!isSuccessfullyUpdated && !isLoadingUpdates" [class.zx-100-opp]="isLoadingUpdates"
                class="d-flex flex-column flex-lg-row flex-grow-lg-1 justify-content-center align-items-end w-100 gap-3">
                <button [disabled]="newPoints === 0 || !newPoints" color="primary" mat-raised-button
                    (click)="triggerFormSubmit()" class="text-white rounded-pill zx-btn-single col-12 col-lg-6 fw-bold">
                    <span>{{ "add-pts.btn-" + action | translate }}</span>
                    <span class="zx-100-opp">-</span>
                    <span>{{ newPoints === null ? '0' : newPoints }}</span>
                    <span class="zx-100-opp">-</span>
                    <span>{{ "printing-table.points-short" | translate }}</span>
                </button>
                <button (click)="closeAddPointsDialog()" color="primary" mat-button
                    class="rounded-pill zx-btn-single col-12 col-lg-6 fw-bold">
                    {{ "su-management.branches_cancel" | translate }}
                </button>
            </div>

            <img *ngIf="isSuccessfullyUpdated && !isLoadingUpdates" src="assets/images/success-icon.svg"
                class="svg zx-success-icon position-absolute" alt="successfull order">

            <div *ngIf="isLoadingUpdates" class="w-100 d-flex justify-content-center flex-grow-1 align-items-center">
                <mat-spinner class="zx-medium-icon-size"></mat-spinner>
            </div>
        </div>

    </div>
</div>